import { render } from "./Configurator.vue?vue&type=template&id=3c065127&scoped=true&ts=true"
import script from "./Configurator.vue?vue&type=script&lang=ts"
export * from "./Configurator.vue?vue&type=script&lang=ts"

import "./Configurator.vue?vue&type=style&index=0&id=3c065127&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c065127"]])

export default __exports__